import React, { useState, useEffect, MouseEvent, ChangeEvent } from 'react'
import AppState from './types/AppState'
import AppProps from './types/AppProps'
import ViewProps from './types/ViewProps'
import LandingPage from './Views/LandingPage'
import Questions from './Views/Questions'
import Result from './Views/Result'

import {
	HashRouter as Router,
	Switch,
	Route,
	Redirect,
} from "react-router-dom"

export default ({ data }: AppProps) => {
	const [ appState, setAppState ] = useState<AppState>({ loading: true })

	if (appState.loading) {
		fetch('/quizindex')
		.then(res => res.json())
		.then(res => setAppState({ ...appState, entries: res.data, loading: false }))
	}

	return (
		<Router>
			<Switch>
				<Route exact path="/">
					<LandingPage {...appState} />
				</Route>
				<Route path="/questions">
					<Questions {...appState} data={data} />
				</Route>
				<Route exact path="/result">
					<Redirect to="/" />
				</Route>
				<Route path="/result/:profileId?/:programId?">
					<Result {...appState} data={data} />
				</Route>
			</Switch>
		</Router>
	)
}